import React, { useMemo } from "react";
import { VStack, Box, StackDivider } from "@chakra-ui/react";
import Item from "./Item";
import EmptyBox from "components/EmptyBox";
import { useAthleteWithoutWorkoutsQuery } from "lib/api/sdk";
import AdminCard from "components/AdminCard";
import { useTranslations } from "next-intl";
import { useDashboardContext } from "src/contexts/DashboardContext";

const RenderData = () => {
  const {startDate, endDate} = useDashboardContext();
  const {loading, data: {athletes: data} = {athletes: []} } = useAthleteWithoutWorkoutsQuery({variables: {_gte_date: startDate, _lte_date: endDate}});

  const t = useTranslations("pages.homePage.runningOutOfWorkouts");
  if (loading)
    return (
      <VStack w="full" spacing={4} divider={<StackDivider />}>
        {[0, 1, 2].map(i => (
          <Item key={i} isLoading />
        ))}
      </VStack>
    );

  if (data && data.length)
    return (
      <VStack w="full" spacing={4} divider={<StackDivider />}>
        {data.map((athlete: any) => (
          <Item key={athlete.id} isLoading={loading} athlete={athlete} />
        ))}
      </VStack>
    );

  return (
    <Box w="full">
      <VStack w="full" spacing={4} divider={<StackDivider />}>
        <EmptyBox message={t("noAthletesToShow")} />
      </VStack>
    </Box>
  );
};

const RunningOutOfWorkoutsCard = () => {
  const t = useTranslations("pages.homePage.runningOutOfWorkouts");
  return (
    <AdminCard h="full" title={t("athletesWithoutWorkouts")}>
      <RenderData/>
    </AdminCard>
  );
};

export default RunningOutOfWorkoutsCard;
